<template>
    <v-dialog
        v-model="dialog"
        persistent
        max-width="550"
    >
        <v-card>
            <v-card-title class="headline">
                {{ title }}
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                v-model="form.document_no"
                                v-validate="'required'"
                                :error-messages="errorMessages('document_no')"
                                :class="{ 'error--text': hasErrors('document_no') }"
                                class="primary--text"
                                name="document_no"
                                label="Numar document"
                                data-vv-as="Numar document"
                                data-vv-name="document_no"
                            />
                            <v-menu
                                v-model="dateMenu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="form.payment_date"
                                        v-validate="'required'"
                                        :error-messages="errorMessages('payment_date')"
                                        :class="{ 'error--text': hasErrors('payment_date') }"
                                        label="Data platii"
                                        data-vv-as="Data platii"
                                        name="payment_date"
                                        data-vv-name="payment_date"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="form.payment_date"
                                    @input="dateMenu = false"
                                ></v-date-picker>
                            </v-menu>
                            <v-text-field
                                v-model="form.amount"
                                v-validate="'required'"
                                :error-messages="errorMessages('amount')"
                                :class="{ 'error--text': hasErrors('amount') }"
                                class="primary--text"
                                name="amount"
                                label="Valoare"
                                data-vv-as="Valoare"
                                data-vv-name="amount"
                                type="number"
                            />
                            <v-select
                                :items="paymentTypes"
                                v-model="form.method"
                                v-validate="'required'"
                                :error-messages="errorMessages('method')"
                                :class="{ 'error--text': hasErrors('method') }"
                                class="primary--text"
                                name="method"
                                label="Metoda de plata"
                                data-vv-as="Metoda de plata"
                                data-vv-name="method"
                            />
                            <v-textarea
                                v-model="form.remarks"
                                v-validate="''"
                                :error-messages="errorMessages('remarks')"
                                :class="{ 'error--text': hasErrors('remarks') }"
                                class="primary--text"
                                name="remarks"
                                label="Observatii"
                                data-vv-as="Observatii"
                                data-vv-name="remarks"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="orange darken-1"
                    text
                    @click="$emit('close')"
                >
                    Renuntare
                </v-btn>
                <v-btn
                    color="green darken-1"
                    text
                    @click="submit"
                >
                    Confirmare
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
    import validationError from "Mixins/validation-error";
    import {Form} from "vform";
    export default {
        mixins: [validationError],
        props: {
            payment: {
                type: Object,
                required: true,
                default() {
                    return {}
                }
            },
            expense: {
                type: Object,
                required: true,
                default() {
                    return {}
                }
            },
            dialog: {
                type: Boolean,
                default() {
                    return false
                }
            },
            title: {
                type: String,
                default() {
                    return 'Inregistrare plata'
                }
            }
        },
        data () {
            return {
                form: new Form(this.payment),
                dateMenu: false,
                paymentTypes: [{
                    value: 'CASH',
                    text: 'Numerar'
                },{
                    value: 'BANK_TRANSFER',
                    text: 'Transfer bancar'
                },{
                    value: 'TICKET',
                    text: 'Tichete'
                }]
            }
        },
        methods: {
            async submit() {
                let self = this;
                this.$validator.validateAll().then(result => {
                    if (result) {
                        // eslint-disable-next-line
                        self.createOrUpdate();
                    } else {
                        this.showError()
                    }
                });
            },
            async createOrUpdate() {
                let self = this;
                self.form.busy = true;

                if(this.form.id) {
                    new this.$db.Expense({id: self.expense.id})
                        .payments()
                        .custom(`expenses/${self.expense.id}/payments/${this.form.id}`)
                        .sync(this.form)
                        .then(response => {
                            self.$validator.reset();
                            self.showSuccess();
                            self.$emit('close', response?.data)
                        })
                        .catch(errors => {
                            self.form.errors.set(this.form.extractErrors(errors.response))
                            this.showError()
                        }).finally(() => {
                        self.form.busy = false;
                    });
                } else {
                    new this.$db.Expense({id: self.expense.id}).payments().attach(self.form)
                        .then(response => {
                            self.$validator.reset();
                            self.showSuccess();
                            self.$emit('close', response?.data)
                        })
                        .catch(errors => {
                            self.form.errors.set(this.form.extractErrors(errors.response))
                            this.showError()
                        }).finally(() => {
                        self.form.busy = false;
                    });
                }
            }
        }
    }
</script>
